<template>
  <van-field
    v-model="value"
    :label="label"
    :colon="true"
    :type="type"
    :readonly="readonly"
    :maxlength="maxlength"
    :placeholder="placeholder"
    clearable
    class="input-field"
    @input="handleChange"
  >
    <template slot="right-icon">
      <div class="right">
        <slot name="right">
          <van-icon v-if="readonly" name="arrow" class="arrow" />
        </slot>
      </div>
    </template>
    <template #label>
      <van-tag
        size="medium"
        :color="label === '姓名' ? 'white' : label === '优惠卡号' ? 'white' : '#eed'"
        text-color="black"
        :style="{ width: `${label === '姓名' ? '' : '55%'}` }"
        @click.stop="handleNoType(label, 'noType')"
      >
        {{ label }}
        <van-icon :name="nameIcon" size="10" v-if="label !== '姓名'" />
      </van-tag>
    </template>
  </van-field>
</template>
<script>
export default {
  props: {
    label: [String],
    nameIcon: [String],
    placeholder: [String],
    type: {
      type: String,
      default: 'text',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    setValue(val) {
      this.value = val;
    },
    handleChange(val) {
      this.$emit('change', val);
    },
    handleNoType(label, noType) {
      if (label !== '姓名' && label !== '优惠卡号') {
        this.$emit('change', noType);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.input-field {
  &::after {
    border: none;
  }
  .right {
    color: #faad14;
    .arrow {
      color: #969799;
    }
  }
}
</style>
